import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import Quantite from '../forms/Quantite';

export default function CardOptionUniteTravail({ uniteTravail, val }) {

	return (

		<Grid container sx={{ p: 0, mb: 4, color: '#555555', borderRadius: 2, boxShadow: 2 }} direction="row" justifyContent="center" alignItems="center" >

			<Grid item xs={12} sm={4} md={3} lg={3}>
				<img src={process.env.REACT_APP_PATH_IMAGES + '/' + uniteTravail.picturePath} alt={uniteTravail.pictureDescription} style={{ width: '100%', height: 'auto', borderRadius: 2, verticalAlign: 'top' }} />
			</Grid>

			<Grid item xs={12} sm={8} md={6} lg={6} sx={{ px: 2, textAlign: 'center' }}>
				<Typography pt={{xs: 3, sm: 0.5}}  sx={{ color: '#004AFE', textAlign: 'center', fontSize: 20, fontWeight: 600 }}>
					{uniteTravail.name}
				</Typography>

				<Typography sx={{ p: 1, pb: 2 }}>
					{uniteTravail.description}
				</Typography>
			</Grid>

			{/* Affiche du prix et de la quantité selon la taille de la fenetre */}
			<Grid item xs={3} sx={{ display: { xs: "none", md: "block" } }} align="center">
				<Typography component="div" align="center" variant="price_option">
					{uniteTravail.forfaitMainOeuvre}
					<Typography component="span" align="center" variant="currency">€</Typography>
					<Typography component="span" align="center">/unité</Typography>
				</Typography>
				<Box py={{ xs: 1 }} px={{ xs: 2 }}>
					<Quantite id={uniteTravail.workUnitKey} val={val} min={uniteTravail.quantiteMin} max={uniteTravail.quantiteMax} />
				</Box>
			</Grid>
			{/* Affiche du prix et de la quantité selon la taille de la fenetre */}
			<Grid item xs={6} sm={4} sx={{ display: { xs: "block", md: "none" } }} align="center">
				<Typography component="div" align="center" variant="price_option">
					{uniteTravail.forfaitMainOeuvre}
					<Typography component="span" align="center" variant="currency">€</Typography>
					<Typography component="span" align="center">/unité</Typography>
				</Typography>
			</Grid>
			<Grid item xs={6} sm={8} sx={{ display: { xs: "block", md: "none" } }} align="center">
				<Box py={{ xs: 2, sm: 3 }} px={{ xs: 2, sm: 3 }}>
					<Quantite id={uniteTravail.workUnitKey} val={val} min={uniteTravail.quantiteMin} max={uniteTravail.quantiteMax} />
				</Box>
			</Grid>

		</Grid>

	);
}